import { PocIcon } from 'commons/components/components-wrapper';
import { useTranslation } from 'core/i18n/i18n';
import { ASYNC_REQUEST_DEFAULT_TIMEOUT } from 'modules/operators/constants/constants';
import { useState } from 'react';
import { CopiedButtonStyled, CopyButtonStyled } from './copy-button.style';

interface CopyButtonComponentProps {
    valueToCopy: string;
}

export const CopyButtonComponent: React.FC<CopyButtonComponentProps> = (props) => {
    const { valueToCopy } = props;
    const { t } = useTranslation();

    const [copiedValue, setCopiedValue] = useState<boolean>(false);

    const copyCode = () => {
        navigator.clipboard.writeText(valueToCopy).then(() => {
            setCopiedValue(true);
            setTimeout(() => setCopiedValue(false), ASYNC_REQUEST_DEFAULT_TIMEOUT);
        });
    };

    return (
        <>
            {copiedValue ? (
                <CopiedButtonStyled data-testid="copy-button" variant="tertiary">
                    <PocIcon name="confirm" slot="prefix" />
                    {t('commons.components.detail-field.copied-button')}
                </CopiedButtonStyled>
            ) : (
                <CopyButtonStyled data-testid="copy-button" variant="tertiary" onClick={() => copyCode()}>
                    <PocIcon name="copy" slot="suffix" />
                    {t('commons.components.detail-field.copy-button')}
                </CopyButtonStyled>
            )}
        </>
    );
};
